import PropTypes from "prop-types"

const EngagementLineDataShape = {
  engagementPercentage: PropTypes.number.isRequired,
  responses: PropTypes.number.isRequired,
  month: PropTypes.string.isRequired,
}
export default EngagementLineDataShape



// WEBPACK FOOTER //
// ./src/state/shapes/EngagementLineDataShape.js